// extracted by mini-css-extract-plugin
module.exports = {"estad_head":"Statistics__estad_head__HzVD"};